import { Link } from "react-router-dom";
import { categories } from "@/utils/media";

const footerLinks = [
  { label: "首页推荐", to: "/" },
  { label: "日韩电影", to: "/category/movie" },
  { label: "日韩电视剧", to: "/category/tv" },
  { label: "日韩综艺", to: "/category/variety" },
  { label: "影视资讯", to: "/news" },
  { label: "站内搜索", to: "/search" },
];

const hotLinks = [
  { label: "首尔夜行", to: "/detail/seoul-night-walk" },
  { label: "汉江以北", to: "/detail/north-of-han" },
  { label: "东京·雨停之后", to: "/detail/rain-in-tokyo" },
  { label: "月见食堂", to: "/detail/tsukimi-diner" },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200/80 bg-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="relative flex h-9 w-9 items-center justify-center rounded-lg bg-primary-950 text-[13px] font-semibold text-background-50">
                日韩
                <span className="absolute -right-0.5 -top-0.5 h-1.5 w-1.5 rounded-full bg-accent-500" />
              </span>
              <span className="font-heading text-base font-semibold text-foreground-950">日韩影视大全</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              专注日韩电影、电视剧与综艺的资料库。按类型、地区、年份浏览作品，查看详情、收藏片单，跟踪最新影视资讯。
            </p>
            <div className="mt-4 flex items-center gap-2">
              <span className="rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-800">
                收录 24 部
              </span>
              <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-800">
                资讯 6 篇
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-label text-[11px] uppercase tracking-[0.2em] text-foreground-500">浏览分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${category.slug}`}
                    className="inline-flex cursor-pointer items-center gap-1.5 text-sm text-foreground-700 transition-colors hover:text-primary-700"
                  >
                    {category.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-[11px] uppercase tracking-[0.2em] text-foreground-500">热门内容</h3>
            <ul className="mt-4 space-y-2.5">
              {hotLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="inline-flex cursor-pointer items-center gap-1.5 text-sm text-foreground-700 transition-colors hover:text-primary-700"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-[11px] uppercase tracking-[0.2em] text-foreground-500">关于与联系</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              {footerLinks.slice(4).map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="cursor-pointer transition-colors hover:text-primary-700">
                    {link.label}
                  </Link>
                </li>
              ))}
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-foreground-400" />
                <span className="text-foreground-600">hello@rihan-cinema.demo</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base text-foreground-400" />
                <span className="text-foreground-600">内容编辑部 · 线上运营</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 日韩影视大全. 本站为影视资料展示站点，所有作品与资讯均为虚构演示内容。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <Link to="/news" className="cursor-pointer transition-colors hover:text-primary-700">
              资讯条款
            </Link>
            <Link to="/search" className="cursor-pointer transition-colors hover:text-primary-700">
              站内搜索
            </Link>
            <span className="text-foreground-400">友情链接：日韩字幕组 · 亚洲影展手册</span>
          </p>
        </div>
      </div>
    </footer>
  );
}